import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  Input,
  NgZone,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { DOCUMENT, NgClass, NgStyle, TitleCasePipe } from '@angular/common';
import { DragScrollType } from '@app/models/client/drag-scroll.type';
import { B2bDeviceUtilService } from '@app/services/util-services/root-services/b2b-device-util.service';
import { ContainerModel } from '@app/models/server/layout.model';
import { SafePipe } from '@app/components/pipes/safe/safe.pipe';
import {RouterLink} from '@angular/router';

@Component({
  selector: 'app-b2b-drag-scroll',
  templateUrl: './b2b-drag-scroll.component.html',
  styleUrls: ['./b2b-drag-scroll.component.scss'],
  standalone: true,
  imports: [NgStyle, SafePipe, TitleCasePipe, NgClass, RouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class B2bDragScrollComponent implements OnInit, AfterViewInit {
  @Input() dragToId: string;
  @Input() container!: ContainerModel | undefined;
  @Input() showHeader: boolean = false;
  @Input() limitDescToMaxLength: boolean = false;
  @Input() hidden: boolean = false;

  @ViewChild('scrollContainer', { static: true })
  scrollContainerRef: ElementRef;

  @Input({ required: true }) config: DragScrollType = {
    autoHeight: true,
    spaceBetween: 5,
    navigation: true,
    freeMode: false,
    mousewheel: false,
    grabCursor: false,
    pagination: true,
    slidesPerView: 1,
    centeredSlides: false,
    injectStyles: [],
    hideScrollButtons: false,
    showAbsoluteButtons: false,
  };

  private isDown = false;
  private startX = 0;
  private scrollLeft = 0;

  constructor(
    @Inject(DOCUMENT) private readonly document: Document,
    private renderer: Renderer2,
    private b2bDeviceUtilService: B2bDeviceUtilService,
    private ngZone: NgZone,
    private cdref: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    // TODO need to handle default drag with opacity
    /*if (this.dragToId && !this.b2bDeviceUtilService?.isServer()) {
      this.hidden = true;
    }*/
    if (this.dragToId && !this.b2bDeviceUtilService?.isServer()) {
      this.hidden = true;
    }
  }

  ngAfterViewInit(): void {
    const scroll = this.scrollContainerRef?.nativeElement;

    if (!scroll) {
      return;
    }

    // Mouse Up Function
    scroll.addEventListener('mouseup', () => {
      this.isDown = false;
      scroll.classList.remove('active');
    });

    // Mouse Leave Function
    scroll.addEventListener('mouseleave', () => {
      this.isDown = false;
      scroll.classList.remove('active');
    });

    // Mouse Down Function
    scroll.addEventListener('mousedown', (e: any) => {
      e.preventDefault();
      this.isDown = true;
      scroll.classList.add('active');
      this.startX = e.pageX - scroll.offsetLeft;
      this.scrollLeft = scroll.scrollLeft;
    });

    // Mouse Move Function
    scroll.addEventListener('mousemove', (e: any) => {
      if (!this.isDown) {
        return;
      }
      e.preventDefault();
      this.renderer.setStyle(
        this.scrollContainerRef?.nativeElement,
        'scroll-behavior',
        'unset',
      );
      const element = e.pageX - scroll.offsetLeft;
      const scrolling = (element - this.startX) * 2.5;
      scroll.scrollLeft = this.scrollLeft - scrolling;
    });

    if (this.config?.mousewheel) {
      scroll.addEventListener('wheel', (evt) => {
        evt.preventDefault();
        scroll.scrollLeft += evt.deltaY;
      });
    }

    if (this.dragToId && !this.b2bDeviceUtilService?.isServer()) {
      this.ngZone.runOutsideAngular(() => {
        setTimeout(() => {
          const offsetLeft: number = this.document?.getElementById(
            this.dragToId,
          )?.offsetLeft;
          if (offsetLeft) {
            if (offsetLeft > 100) {
              scroll.scrollLeft = offsetLeft + scroll.scrollLeft - 100;
            } else {
              scroll.scrollLeft = offsetLeft + scroll.scrollLeft;
            }
          }
          this.hidden = false;
          this.cdref?.markForCheck();
        }, 750);
      });
    }
  }

  goBack() {
    this.scrollTo(false);
  }

  goForward() {
    this.scrollTo(true);
  }

  scrollTo(isForward: boolean) {
    const scroll = this.scrollContainerRef?.nativeElement;
    if (!scroll) {
      return;
    }
    const scrollLeft: number = this.getScrollLeft();

    this.renderer.setStyle(
      this.scrollContainerRef?.nativeElement,
      'scroll-behavior',
      'smooth',
    );
    if (isForward) {
      scroll.scrollLeft += scrollLeft;
    } else {
      scroll.scrollLeft -= scrollLeft;
    }
  }

  getScrollLeft() {
    let scrollLeft = 300;

    const scroll = this.scrollContainerRef?.nativeElement;
    if (!scroll) {
      return scrollLeft;
    }

    if (this.config?.slidesPerView) {
      const oneSlideWidth: number =
        scroll?.offsetWidth / Number(this.config?.slidesPerView);

      if (Number(this.config?.slidesPerView) < 2) {
        scrollLeft = oneSlideWidth;
      } else {
        scrollLeft = oneSlideWidth * (Number(this.config?.slidesPerView) - 1);
      }
    } else {
      scrollLeft = 300;
    }
    return scrollLeft;
  }

  onSeeAll() {
    // TODO need to write the logic
  }
}
